import {toolbarConfigs} from "../../configs/toolbarConfigs";
import {useToolbarConfiguration} from "../../hooks/useToolbarConfiguration";


export const ToolbarManager = ({children}) => {
    useToolbarConfiguration(toolbarConfigs)
    return children;
}
